import { CIcon } from '~/icons/types'

export const ciBookmark: CIcon = {
  width: '20',
  height: '20',
  paths: [
    {
      d:
        'M14.75 2.167a45.344 45.344 0 0 0-9.5 0C4 2.334 3.167 3.334 3.167 4.584V17.5c0 .25.083.417.333.5a.711.711 0 0 0 .584 0l6-3 6 3a.711.711 0 0 0 .583 0c.167-.083.333-.333.333-.5V4.584c-.166-1.25-1-2.25-2.25-2.417Z',
      clipRule: 'evenodd'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'bookmark',
  type: 'solid'
}
